module.exports = __webpack_public_path__ + "img/occupation_white.fba9f12.svg";